import { api } from './backend'; 

export const list =(page, limit, filters)=> api.get('/front/videos-playlists',{ params: { page, limit, ...filters }}); 

export const findAll =()=> api.get('/front/playlists'); 

export const findById = (id) => api.get(`/front/playlists/${id}`);
